var React = require('react');

function ArrowSponsors (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Combined Shape"),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","key":1},React.createElement("g",{"id":"direct-link-icon-/-copy","transform":"translate(-4.000000, -10.000000)","fillRule":"nonzero","stroke":"#99DBCF"},React.createElement("g",{"id":"Up","transform":"translate(11.500000, 12.500000) scale(-1, 1) rotate(90.000000) translate(-11.500000, -12.500000) translate(9.000000, 5.000000)"},React.createElement("g",{"id":"Group","transform":"translate(0.500000, 0.500000)"},React.createElement("path",{"d":"M0,12 L1.99411931,14 L4,12 M2,13.998554 L2,-2.14939178e-13","id":"Combined-Shape"})))))]);
}

ArrowSponsors.defaultProps = {"width":"15px","height":"5px","viewBox":"0 0 15 5","version":"1.1"};

module.exports = ArrowSponsors;

ArrowSponsors.default = ArrowSponsors;
